"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");exports.__esModule=!0,exports.default=chooseImage,exports.ImageType=void 0;var ImageType,_invoker=_interopRequireDefault(require("./invoker"));function chooseImage(e){return _invoker.default.invoke("dgChooseImage",e)}exports.ImageType=ImageType,function(e){e[e.image=0]="image",e[e.video=1]="video"}(ImageType||(exports.ImageType=ImageType={})),_invoker.default.registerAPI("dgChooseImage",{mini:!0,mobile:!0,pc:function(e,o){window.dingtalk.platform.invokeAPI(o.msgId,"biz.util.dgChooseImage",e)}});


//////////////////
// WEBPACK FOOTER
// ./node_modules/gdt-jsapi/chooseImage.js
// module id = 0NOH
// module chunks = 23